import { useMemo } from "react";
import { useSelector } from "react-redux";
import { selectIsRegistration } from "../store/authentication/authSlice";

export const useRegistration = () => {
  const isRegistration = useSelector(selectIsRegistration);

  return useMemo(() => isRegistration, [isRegistration]);
};
